import { render, staticRenderFns } from "./SelectLocation.vue?vue&type=template&id=3dd68b98"
import script from "./SelectLocation.vue?vue&type=script&lang=ts"
export * from "./SelectLocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports